var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3337 22.0004C11.2542 22.0004 12.0004 21.2542 12.0004 20.3337C12.0004 19.4132 11.2542 18.667 10.3337 18.667C9.41319 18.667 8.66699 19.4132 8.66699 20.3337C8.66699 21.2542 9.41319 22.0004 10.3337 22.0004Z",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6677 22.0004C18.5881 22.0004 19.3343 21.2542 19.3343 20.3337C19.3343 19.4132 18.5881 18.667 17.6677 18.667C16.7472 18.667 16.001 19.4132 16.001 20.3337C16.001 21.2542 16.7472 22.0004 17.6677 22.0004Z",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6657 18.6664H9.6657C8.74537 18.6664 7.99902 17.92 7.99902 16.9997C7.99902 16.0794 8.74537 15.333 9.6657 15.333",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 7.33398H6.00098C6.00098 7.33398 6.96998 11.2103 7.55898 13.5666C7.81865 14.6053 8.75197 15.334 9.82264 15.334C12.084 15.334 15.918 15.334 18.1793 15.334C19.25 15.334 20.1833 14.6053 20.443 13.5666C21.032 11.2103 22.001 7.33398 22.001 7.33398Z",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33332C6 7.33332 5.65332 5.94631 5.31332 4.58697C4.93332 3.06668 3.56734 2 2 2",
    stroke: "#111111",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.822151f4e7ffaf0e09ce27ebb6abe6c9.svg";
export { ForwardRef as ReactComponent };